import React from 'react';

export const Lobby = React.lazy(() => import('./Lobby'));
